import { useEffect, useRef, RefObject } from 'react';

/**
 * Hook pour la gestion du focus et du clavier dans les modals
 * @param isOpen - État d'ouverture du modal
 * @param onClose - Fonction de fermeture du modal
 * @returns Ref à attacher au modal
 */
export function useModalAccessibility(
  isOpen: boolean,
  onClose: () => void
): RefObject<HTMLDivElement> {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    // Focus sur le modal lors de l'ouverture
    const focusableElements = modalRef.current?.querySelectorAll<HTMLElement>(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (focusableElements && focusableElements.length > 0) {
      focusableElements[0].focus();
    }

    // Gestion de la touche Escape
    const handleEscape = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  return modalRef;
}
